import { Target, BarChart3, Users, Zap } from "lucide-react";

const PILLARS = [
  {
    icon: Target,
    title: "Specializați, nu generaliști",
    desc: "Google Ads și Social Media. Atât. Făcute la nivel de expert, nu de stagiar.",
    color: "#E91E8B",
  },
  {
    icon: BarChart3,
    title: "Tracking corect din start",
    desc: "GA4 server-side, conversion API, Looker Studio. Decizii pe date, nu pe presupuneri.",
    color: "#2962FF",
  },
  {
    icon: Users,
    title: "Un singur point of contact",
    desc: "Un strateg dedicat care vă cunoaște business-ul. Fără account managers care pasează mailuri.",
    color: "#E91E8B",
  },
  {
    icon: Zap,
    title: "Lucrăm la viteza voastră",
    desc: "Lansăm campanii în 7-10 zile. Optimizăm săptămânal. Raportăm lunar, scurt și clar.",
    color: "#2962FF",
  },
];

const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-20 lg:py-32 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-500">
              <span className="h-px w-8 bg-electric" />
              Despre C2
            </div>
            <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900">
              Performance fără{" "}
              <span className="text-magenta">vrăjeală</span>.
            </h2>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Suntem o agenție mică, construită din oameni care au lucrat in-house pe bugete reale.
              Lucrăm cu maxim 15 clienți simultan ca să putem rămâne concentrați pe ce contează: rezultatele voastre.
            </p>
            <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-5">
              <div className="text-xs text-slate-500 font-semibold uppercase tracking-wider">Filosofia noastră</div>
              <blockquote className="mt-2 font-display text-xl font-semibold text-slate-900 leading-snug">
                „Marketingul bun nu se vinde pe sloganuri. Se vede în P&L-ul vostru la sfârșit de lună.”
              </blockquote>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 lg:gap-6">
            {PILLARS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`pillar-${i}`}
                  className="rounded-2xl bg-white border border-slate-200 p-6 lg:p-7 hover:border-slate-300 transition-colors"
                >
                  <div
                    className="h-11 w-11 rounded-xl grid place-items-center"
                    style={{ backgroundColor: `${p.color}14`, color: p.color }}
                  >
                    <Icon size={22} />
                  </div>
                  <h3 className="font-display mt-5 text-xl font-bold text-slate-900">{p.title}</h3>
                  <p className="mt-2 text-slate-600 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
